export default "__VITE_ASSET__9834b7ce__"